import type { AllRepositories } from "@pack-it-up/core";

// Dev-only: populate the in-memory backend with a signed-in demo user and a sample trip
// so `pnpm run dev:web:offline` opens on a populated app instead of an empty sign-in
// screen. Uses only repository interfaces (no `data` import), and runs once per page
// load (the in-memory store resets on reload).
export const seedDemo = async (repos: AllRepositories): Promise<void> => {
  const user = await repos.auth.signUp("demo@example.com", "password", "Demo User");
  if (!user.ok) return;

  const trip = await repos.trips.createTrip({
    name: "Japan — Spring '26",
    startDate: "2026-04-02",
    endDate: "2026-04-18",
    location: "Tokyo, Japan",
  });
  if (!trip.ok) return;

  const clothing = await repos.categories.createCategory({ name: "Clothing", parentId: trip.value });
  const tech = await repos.categories.createCategory({ name: "Tech & Electronics", parentId: trip.value });

  if (clothing.ok) {
    await repos.items.createItem({ categoryId: clothing.value, name: "Merino base layer", quantity: 2 });
    await repos.items.createItem({ categoryId: clothing.value, name: "Rain jacket", quantity: 1 });
    await repos.items.createItem({ categoryId: clothing.value, name: "Walking shoes", quantity: 1 });
    await repos.todos.createTodo({ categoryId: clothing.value, name: "Buy travel insurance" });
  }
  if (tech.ok) {
    await repos.items.createItem({ categoryId: tech.value, name: "Universal power adapter", quantity: 2 });
    await repos.items.createItem({ categoryId: tech.value, name: "Battery pack", quantity: 1 });
  }

  // A second, dateless trip to show the home grouping.
  await repos.trips.createTrip({ name: "Weekend in Lisbon" });
};
